import { planActionTypes } from '../actions/types';
import _ from 'lodash';

const initialState = {
    plans: []
};

export function plan(state = initialState, action) {
    switch (action.type) {
        case planActionTypes.RESET_STATE:
            return {
                ...initialState,
            };
        case planActionTypes.GETALL_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case planActionTypes.GETALL_SUCCESS:
            return {
                ...state,
                plans: action.plans,
                loading: false,
            };
        case planActionTypes.GETALL_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        case planActionTypes.CREATE_REQUEST:
            return {
                ...state,
                status: 'loading',
                error: null,
            };
        case planActionTypes.CREATE_SUCCESS:
            return {
                ...state,
                status: 'success',
                plans: [action.plan, ...state.plans],
                error: null,
            };
        case planActionTypes.CREATE_FAILURE:
            return {
                ...state,
                status: 'failed',
                error: action.error,
            };
        case planActionTypes.UPDATE_REQUEST:
            return {
                ...state,
                status: 'loading',
                error: null,
            };
        case planActionTypes.UPDATE_SUCCESS:
            return {
                ...state,
                status: 'success',
                // plans: state.plans.map(plan => action.plan.find(o => o.id === plan.id) || plan),
                plans: [action.plan, ...state.plans],
                error: null,
            };
        case planActionTypes.UPDATE_FAILURE:
            return {
                ...state,
                status: 'failed',
                error: action.error,
            };
        default:
            return state;
    }
}